import React, { useRef, memo } from 'react';
import { motion, useInView } from 'framer-motion';
export function WelcomeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="about" className="w-full bg-[#FAF8F5] py-24 sm:py-32" ref={ref} data-id="element-401">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center" data-id="element-402">
        {/* Decorative Line with Diamonds */}
        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex items-center justify-center gap-3 mb-8" data-id="element-403">
          <span className="text-[#D4A853]/40 text-xs" data-id="element-404">◆</span>
          <motion.div initial={{
          scaleX: 0
        }} animate={isInView ? {
          scaleX: 1
        } : {}} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} className="w-16 h-0.5 bg-[#D4A853] origin-center" data-id="element-405" />
          <span className="text-[#D4A853]/40 text-xs" data-id="element-406">◆</span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-8" data-id="element-407">
          Welcome to Nepal Luxury Travel
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="space-y-5 text-slate-600 text-lg leading-relaxed font-light" data-id="element-408">
          <p data-id="element-409">
            For over fifteen years, we have been curating extraordinary journeys
            through the heart of Nepal. From the soaring peaks of the Himalayas
            to the serene lakes of Pokhara and the ancient temples of Kathmandu
            Valley, every experience is crafted with meticulous attention to
            detail.
          </p>
          <p data-id="element-410">
            Our team of expert local guides, luxury hospitality partners, and
            dedicated concierge staff ensure that every moment of your journey
            is seamless, comfortable, and deeply enriching. We believe luxury
            travel is not just about five-star accommodations — it's about
            authentic connections, exclusive access, and memories that last a
            lifetime.
          </p>
        </motion.div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-16 grid grid-cols-3 gap-4 sm:gap-8" data-id="element-411">
          <div className="border border-[#D4A853]/20 rounded-xl p-5 sm:p-6 border-t-2 border-t-[#D4A853] bg-white/60" data-id="element-412">
            <span className="block font-playfair text-3xl sm:text-4xl font-bold text-teal-600" data-id="element-413">
              15+
            </span>
            <span className="block mt-1 text-sm text-slate-500 font-medium tracking-wide" data-id="element-414">
              Years Experience
            </span>
          </div>
          <div className="border border-[#D4A853]/20 rounded-xl p-5 sm:p-6 border-t-2 border-t-[#D4A853] bg-white/60" data-id="element-415">
            <span className="block font-playfair text-3xl sm:text-4xl font-bold text-teal-600" data-id="element-416">
              500+
            </span>
            <span className="block mt-1 text-sm text-slate-500 font-medium tracking-wide" data-id="element-417">
              Happy Travelers
            </span>
          </div>
          <div className="border border-[#D4A853]/20 rounded-xl p-5 sm:p-6 border-t-2 border-t-[#D4A853] bg-white/60" data-id="element-418">
            <span className="block font-playfair text-3xl sm:text-4xl font-bold text-teal-600" data-id="element-419">
              50+
            </span>
            <span className="block mt-1 text-sm text-slate-500 font-medium tracking-wide" data-id="element-420">
              Luxury Tours
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}